// extracted by mini-css-extract-plugin
export var inlineLink = "_45-0";
export var inlineLinkButton = "_45-1";